/* eslint-disable */
import React, { useEffect, useState, useMemo, useRef } from "react";

import { Link, useParams, useHistory } from "react-router-dom";
import Select from "react-select";

// Import CKEditor here (both required).
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import { useTranslation } from "react-i18next";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import {
  postData,
  getData,
  putData,
  uploadSingleFile,
  uploadMultipleFile,
} from "utils/Gateway";
import { assetImages } from "constants";
import { getDateFormatInSpanish } from "helper/Common/CommonHelper";
import { ckEditorConfig } from "Config/Config";
import downloadFileHandler from "helper/DownloadFile";

const ViewTaskPopup = ({
  selectedTaskId,
  setSelectedTaskId,
  afterPopupclose,
  setShowAlert,
  setAlertMessage,
  setMessageType,
}) => {
  const todayValue = new Date().toISOString().split("T")[0];

  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();

  const params = useParams();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [title, settitle] = useState("");
  const [details, setdetails] = useState("");
  const [startDate, setstartDate] = useState("");
  const [submitDate, setsubmitDate] = useState("");
  const [reviewDate, setreviewDate] = useState("");
  const [approvalStatus, setApprovalStatus] = useState("");
  const [completedPercent, setCompletedPercent] = useState("");
  const [lessonName, setlessonName] = useState("");
  const [uploadedDocFiles, setUploadedDocFiles] = useState([]);
  const [score, setscore] = useState("");

  const [commentList, setCommentList] = useState([]);

  const [comment, setComment] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  //get task details
  const getTaskDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_LESSON_TASK_DETAILS +
        `/${selectedTaskId}`;

      // console.log(requestUrl);

      const response = await getData(requestUrl);

      console.log("task details", response);

      if (response.status) {
        settitle(response.data.title);
        setdetails(response.data.description);
        setlessonName(response.data.lessonname);
        setscore(response.data?.score);
        setApprovalStatus(response.data.approvalstatus);
        setCompletedPercent(response.data.completedpercent);
        setstartDate(response.data.taskstartdate);
        setsubmitDate(response.data.tasksubmitdate);
        setreviewDate(response.data.taskreviewdate);

        setCommentList(response.data.comments);

        //assign uploaded files
        setUploadedDocFiles(
          response?.data?.uploadedfiles.map(
            ({ name, path, _id, ...other }) => ({
              name,
              path: url.SERVER_URL + path,
              _id,
            })
          )
        );
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for task approval
  const taskApproveHandler = async (status = "0") => {
    const todayValue = new Date().toISOString().split("T")[0];

    try {
      setIsSaving(true);

      let taskData = {
        approvalstatus: status,
        taskcomment: comment,
        followers: [userInfo._id],
      };

      if (status === "1") {
        // taskData.completedpercent = "3";
        taskData.reviewdate = todayValue;
        taskData.submitstatus = "3";
      }

      if (status === "2") {
        taskData.submitstatus = "4";
      }

      // console.log(taskData);

      let requestURL =
        url.API_BASE_URL +
        url.API_UPDATE_LESSON_ASSIGNMENT +
        `/${selectedTaskId}`;

      const response = await putData(requestURL, taskData);

      setIsSaving(false);

      console.log(response);

      if (response.status) {
        setMessageType("success");
        resetHandler();
        let offCanvasPopup = document.querySelector("#viewTask");
        let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
        offCanvas.hide();
        afterPopupclose();
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      console.log(error.message);
      setMessageType("error");
      setAlertMessage(error.message);
    }
    setShowAlert(true);
  };

  // Reset all the form fields and state variables to their initial values
  const resetHandler = () => {
    settitle("");
    setdetails("");
    setlessonName("");
    setUploadedDocFiles([]);
    setCommentList([]);
    setComment("");
    setSelectedTaskId(null);
  };

  // useEffect for getting task details
  useEffect(() => {
    if (selectedTaskId) {
      getTaskDetails();
    }
  }, [selectedTaskId]);

  return (
    <div
      className="offcanvas md offcanvas-end bg-white border-0"
      tabIndex="-1"
      id="viewTask"
      aria-labelledby="viewTaskLabel"
    >
      <div className="offcanvas-header gradient-light p-4">
        <div>
          <h3 className="offcanvas-title mb-2" id="viewTaskLabel">
            Review assignments by subscribers
          </h3>

          <div className="mb-1 fw-semibold">
            {approvalStatus === "1" ? (
              <p className="d-flex align-items-center text-success">
                <i className="material-symbols-outlined icon-md me-1">
                  check_circle
                </i>{" "}
                Accepted and Approved
              </p>
            ) : approvalStatus === "2" ? (
              <p className="d-flex align-items-center text-danger">
                <i className="material-symbols-outlined icon-md me-1">
                  access_time
                </i>{" "}
                Rejected
              </p>
            ) : (
              <p className="d-flex align-items-center text-danger">
                <i className="material-symbols-outlined icon-md me-1">
                  access_time
                </i>{" "}
                Pending Approval
              </p>
            )}
          </div>
        </div>

        {/* <ul className="task-category d-flex flex-wrap ">
            <li className="position-relative">{lessonName}</li>
           
            <li className="position-relative">IT Gients</li>
            <li className="position-relative">Technology</li>
          </ul> */}

        <button
          type="button"
          className="btn-close p-0 bg-gray-200 rounded-circle shadow-none m-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body d-flex flex-column p-0">
        <div className="task-details flex-fill p-4">
          <p className="fs-md fw-semibold mb-1">Lesson</p>
          <p>{lessonName}</p>

          <p className="fs-md fw-semibold mb-1">Assignment Title</p>
          <p>{title}</p>

          <p className="fs-md fw-semibold mb-1">Assignment Details</p>
          <p
            dangerouslySetInnerHTML={{
              __html: details,
            }}
          ></p>

          <p className="fs-md fw-semibold mb-1">Start Date</p>
          <p>{startDate}</p>

          <p className="fs-md fw-semibold mb-1">Submit Date</p>
          <p>{submitDate}</p>

          <p
            className={reviewDate === "" ? "d-none" : "fs-md fw-semibold mb-1"}
          >
            Review Date
          </p>
          <p className={reviewDate === "" ? "d-none" : ""}>{reviewDate}</p>

          <p
            className={
              uploadedDocFiles.length > 0 ? "fs-md fw-semibold mb-1" : "d-none"
            }
          >
            Attachments
          </p>
          <ul
            className={
              uploadedDocFiles.length > 0
                ? "uploaded-files d-flex flex-wrap gap-3 p-0 m-0 mt-3"
                : "d-none"
            }
          >
            {uploadedDocFiles.map((file, index) => {
              return (
                <li
                  className="file d-flex gap-3 align-items-center px-3 py-2 border border-gray rounded-3"
                  key={index}
                >
                  <Link to="#" onClick={() => downloadFileHandler(file)}>
                    <span className="d-block material-symbols-outlined">
                      download
                    </span>
                  </Link>
                  <p className="fw-medium">{file.name}</p>
                  <Link to="#" onClick={() => closeDocFileHandler(index)}>
                    <span className="d-block material-symbols-outlined">
                      close
                    </span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>

        <div className="logs flex-fill p-4">
          <p className="fs-md fw-semibold mb-1">Comments</p>
          {commentList.map((logData, index) => {
            return (
              <div className="log mt-3" key={index}>
                <div className="d-flex gap-2">
                  <div
                    className="avatar rounded-circle overflow-hidden"
                    style={{ width: "24px", height: "24px" }}
                  >
                    <img
                      src={
                        logData.userimage == ""
                          ? assetImages.defaultUser
                          : url.SERVER_URL + logData.userimage
                      }
                      alt="Richard"
                      className="w-100 h-100 object-fit-cover object-center"
                    />
                  </div>
                  <div>
                    <p className="d-flex align-items-center gap-2 mb-2">
                      <span className="d-block fs-md fw-semibold">
                        {logData.user}
                      </span>
                      <span className="d-block fs-sm text-gray">
                        {logData.startdate}
                      </span>
                    </p>
                    <p
                      className="message body-bg px-3 py-2 fs-sm rounded-10"
                      dangerouslySetInnerHTML={{
                        __html: logData.description,
                      }}
                    ></p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <form
          onSubmit={(e) => e.preventDefault()}
          // className={
          //   approvalStatus === "1" && completedPercent === "3"
          //     ? "d-none"
          //     : "p-4 border-top"
          // }
          className="p-4 border-top"
        >
          <div className="form-group mb-4">
            <label htmlFor="comment" className="d-block fs-sm fw-semibold mb-2">
              Comment on Task Review
            </label>
            <CKEditor
              className="form-control fs-sm shadow-none"
              editor={ClassicEditor}
              config={ckEditorConfig(t("Type comments here..."))}
              data={comment}
              onReady={(editor) => {
                editor.editing.view.change((writer) => {
                  writer.setStyle(
                    "height",
                    "200px",
                    editor.editing.view.document.getRoot()
                  );
                });
              }}
              onChange={(event, editor) => {
                let editorContent = editor.getData();
                setComment(editorContent);
              }}
            />
          </div>

          <div className="action d-flex flex-wrap gap-3 justify-content-between">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                taskApproveHandler("1");
              }}
              style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
              disabled={isSaving ? true : false}
            >
              Approve
              {isSaving && (
                <div
                  className="mx-2 spinner-border spinner-border-sm"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
            </button>
            <button
              className="btn btn-outline-primary"
              onClick={() => {
                taskApproveHandler("2");
              }}
              style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
              disabled={isSaving ? true : false}
            >
              Decline
              {isSaving && (
                <div
                  className="mx-2 spinner-border spinner-border-sm"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ViewTaskPopup;
